import { INDEPENDENT_PISCS } from "../../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case INDEPENDENT_PISCS:
      return {
        ...state,
        items: action.payload
      };

    default:
      return state;
  }
}
